import React from 'react';
import { connect } from 'react-redux';
import { Title } from '../components/Title';

const mapStateToProps = ({ activeExercise }) => ({
   title: activeExercise?.exerciseDocument?.title,
   description: activeExercise?.exerciseDocument?.shortSeoDescription,
});

const ExerciseTitle = connect(mapStateToProps)(
   ({ title, description }) =>
      title && <Title title={title} description={description} />
);

export { ExerciseTitle };
